import Index from './index.vue';

const irrigationRoutes = {
  path: 'irrigation',
  name: 'irrigation.irrigation',
  component: Index,
  meta: {
    prefix_permission: 'irrigation_irrigation',
  },
};

export default irrigationRoutes;
